import React from 'react';
import { makeStyles } from '@material-ui/core';
import { getFileFormat } from 'utils/get-file-format';
import FilePreview from '../../assets/blank_file.png';

interface FileFormatProps {
  contentType: string;
}

const useStyles = makeStyles((theme) => ({
  fileFormatWrapper: {
    width: '100%',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
  },
  format: {
    position: 'absolute',
    width: 50,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 2,
  },
}));

export const FileFormat = ({ contentType }: FileFormatProps) => {
  const classes = useStyles();
  const fileFormat = getFileFormat(contentType);

  return (
    <div className={classes.fileFormatWrapper}>
      <img src={FilePreview} alt="format" width={50} height={55} />
      <div className={classes.format}>{fileFormat}</div>
    </div>
  );
};
